module.exports = __webpack_public_path__ + "static/media/laptop.9834e3c2.svg";